import React, { useState, useEffect } from 'react';
import MyButton from '../../../components/MyButton';
import MyInput from '../../../components/MyInput';
import { useAtomValue } from 'jotai';
import { savingCancellationReasonLoadingAtom } from '../../../atoms/cancellationReasonsAtoms';
import styles from '../css/index.module.scss';

function CancellationReasonFormModal({ editItem, onSave, onClose }) {
  const [name, setName] = useState(editItem?.name ?? '');
  const savingLoading = useAtomValue(savingCancellationReasonLoadingAtom);
  const isEdit = Boolean(editItem?.id);

  useEffect(() => {
    setName(editItem?.name ?? '');
  }, [editItem]);

  const onSubmit = (ev) => {
    ev?.preventDefault?.();
    const trimmed = name?.trim();
    if (!trimmed) return;
    onSave(trimmed);
  };

  return (
    <div className="modal_wrapper">
      <div className="modal_content">
        <p className="modal_title">{isEdit ? 'Редактировать причину отмены' : 'Добавить причину отмены'}</p>
        <form onSubmit={onSubmit} className={styles.form}>
          <MyInput
            value={name}
            onChange={(ev) => setName(ev.target.value)}
            placeholder="Название"
            withLeftIcon={false}
            withCloseIcon={false}
            maxLength={255}
            wrapperClassName={styles.formInputFullWidth}
          />
        </form>
      </div>
      <div className="modal_buttons_row">
        <MyButton text="Отмена" secondary onClick={onClose} disabled={savingLoading} />
        <MyButton
          text={isEdit ? 'Сохранить' : 'Добавить'}
          onClick={onSubmit}
          loading={savingLoading}
          disabled={!name?.trim()}
        />
      </div>
    </div>
  );
}

export default CancellationReasonFormModal;
